export const SERVER_NAME = {
  'demo': 'IUXMarkets-Demo',
  'api': 'IUXMarkets-Live',
  'live': 'IUXMarkets-Live',
  'live1': 'IUXMarkets-Live1',
  'live2': 'IUXMarkets-Live2',
  'live3': 'IUXMarkets-Live3'
}